import { Box, Grid, Typography } from "@mui/material"
import Header from "components/Header/Header"
import { createBreadcrumbs } from "helpers/breadCrumbs"
import React, { useEffect, useState } from "react"
import styles from "./recommendation.module.scss"
import MultipleSelect from "components/StyledComponents/MultipleSelect"
import {
  getRecommendationCategoryListAction,
  getRecommendedCategoryDetailsAction,
  updateRecommendationCategoryDetailsAction
} from "redux/superAdmin/actions"
import { useDispatch, useSelector } from "react-redux"
import AppButton from "components/StyledComponents/AppButton"
import { ChevronRight } from "@mui/icons-material"
import { useTheme } from "@emotion/react"

const RecommondationEngine = () => {
  const [breadCrumbs, setBreadCrumbs] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("")
  const [selectedRoles, setSelectedRoles] = useState([])
  const [rolesList, setRolesList] = useState([])
  const { recommendationCategoryList, recommendedCategoryDetails } = useSelector(
    (store) => store?.superAdmin
  )
  const dispatch = useDispatch()
  const theme = useTheme()

  const handleSave = () => {
    const payload = {
      role_ids: selectedRoles
    }
    dispatch(updateRecommendationCategoryDetailsAction({ id: selectedCategory, payload }))
  }

  useEffect(() => {
    if (recommendationCategoryList?.length > 0) {
      setSelectedCategory(recommendationCategoryList?.[0]?.category_id)
      dispatch(getRecommendedCategoryDetailsAction(recommendationCategoryList[0]?.category_id))
    }
  }, [recommendationCategoryList])

  useEffect(() => {
    const selected = recommendedCategoryDetails?.selected_roles || []
    const available = recommendedCategoryDetails?.available_roles || []

    const formattedSelected = selected?.map((item) => ({
      label: item?.name,
      value: item?.id
    }))
    const formattedAvailable = available?.map((item) => ({
      label: item?.name,
      value: item?.id
    }))

    setSelectedRoles(formattedSelected.map((item) => item.value))
    setRolesList([...formattedSelected, ...formattedAvailable])
  }, [recommendedCategoryDetails])

  useEffect(() => {
    document.title = "Recommendation Engine"
    setBreadCrumbs(createBreadcrumbs())
    dispatch(getRecommendationCategoryListAction())
  }, [])

  return (
    <Grid container spacing={5}>
      <Grid item xs={12}>
        <Header title="Recommendation Engine" breadCrumbs={breadCrumbs}>
          <AppButton className={styles.saveBtn} onClick={() => handleSave()}>
            Save
          </AppButton>
        </Header>
      </Grid>

      <Grid item xs={6}>
        <Box className={styles.categoryContainer}>
          {recommendationCategoryList?.length ? (
            <>
              <Box className={`mb-3 ${styles.categoryHeader}`}>
                <Typography variant="body1small">Select Category</Typography>
              </Box>
              {recommendationCategoryList?.map((item, index) => {
                const isSelected = selectedCategory === item?.category_id
                return (
                  <Box
                    className={styles.tile}
                    key={index}
                    sx={{
                      backgroundColor: isSelected ? theme.palette.primary.hover : "transparent",
                      borderColor: isSelected ? "transparent" : theme.palette.secondary.main
                    }}
                    onClick={() => {
                      setSelectedCategory(item?.category_id)
                      dispatch(getRecommendedCategoryDetailsAction(item?.category_id))
                    }}>
                    <Typography variant="body1Regular" color={theme.palette.text.secondary}>
                      {item?.category_name}
                    </Typography>
                    <ChevronRight />
                  </Box>
                )
              })}
            </>
          ) : (
            <Box className="d-flex justify-content-center">
              <Typography variant="body1small">No Category Found</Typography>
            </Box>
          )}
        </Box>
      </Grid>

      {recommendationCategoryList?.length > 0 && (
        <Grid item xs={6}>
          <Box className={styles.userContainer}>
            <Typography variant="body1small">Select Roles</Typography>
            <Box className="mt-4">
              <MultipleSelect
                menuItems={rolesList}
                isRequired={true}
                value={selectedRoles}
                onChange={(e) => {
                  setSelectedRoles(e.target.value)
                }}
                label="Show to"
                name="userRole"
                placeholder="Select Roles"
              />
            </Box>
          </Box>
        </Grid>
      )}
    </Grid>
  )
}

export default RecommondationEngine
